/* Scroll functions */
(function( $ ) {
    'use strict'

    /* Setup */
    var vw = 0,
        vh = 0,
        vaspectratio = ''

    /* Toggle scrolled state */
    $(window).on('load', function() {
        $( 'body' ).addClass( 'all-ready' )
    }).on( 'resize', function() {
        setViewportSizes()
        setViewportClasses()
    })
    $(document).on( 'ready', function() {
        $( 'body' ).addClass( 'dom-ready' )
        setViewportSizes()
        setViewportClasses()
    })

    function setViewportSizes() {
        /* Set viewport size */
        vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    
        /* Get viewport aspect ratio */
        if ( vw > vh ) {
            vaspectratio = 'landscape'
        } else if ( vw < vh ) {
            vaspectratio = 'portrait'
        } else {
            vaspectratio = 'square'
        }
    }

    function setViewportClasses() {
        /* Set viewport class */
        if ( !document.querySelector( 'body' ).classList.contains( 'is-' + vaspectratio ) ) {
            document.querySelector( 'body' ).classList.remove( 'is-portrait' )
            document.querySelector( 'body' ).classList.remove( 'is-square' )
            document.querySelector( 'body' ).classList.remove( 'is-landscape' )
            document.querySelector( 'body' ).classList.add( 'is-' + vaspectratio ) 
        }
    }
})( $ )